<template>
  <div class="zj-emergency-person-list">
    <div v-for="item in UsersOptions" :key="item.BookId" :label="item.BookId" :value="item.BookId">
      <div style="width:50px;">{{item.name}}</div>
      <div style="width:80px;">{{item.title}}</div>
      <div>{{item.contactNo}}</div>
      <div @click="startCall(item.name,item.contactNo)" class="call-video-btn"  style="display:none;">视频</div>
    </div>
  </div>
</template>
<script>
//import ZJApp from "../../../../../../app";
import { list } from "@/api/src/emergency_person";
export default {
  props: {
    ResourceTypeId: { type: String },
    PersonOrgianiztionId: { type: String },
    InputUsersids: { type: Array },
    PersonName: String,
    ExecutId: {
      type: String,
      required: true
    },
    roomId: {
      type: String
    },
    pwd: {
      type: String
    }
  },
  data() {
    return {
      userradioOptions: [],
      UsersOptions: [],
      Usersids: [],
      msgkey: {
        emergencyVideoCallKey: "MessageKey_EmergencyVideoCall"
      }
    };
  },
  created: function() {
    if (this.ResourceTypeId != "" && this.PersonOrgianiztionId != "") {
      this.GetUserData();
    }
  },
  methods: {
    GetUserData() {
      list({
          belongDeptType: this.ResourceTypeId,
          belongDeptId: this.PersonOrgianiztionId,
          name: this.PersonName
        })
        .then(r => {
          var data = r.data.records;
          if (data) {
            this.UsersOptions = data;
          }
        })
        .catch(e => {
        });
    },
    // eslint-disable-next-line no-unused-vars
    startCall: function(name, phone) {
      //发送启动视频通话的消息，服务后台发送视频通话链接给联系人
      this.$notify.broadcase({
        key: this.msgkey.emergencyVideoCallKey,
        data: {
          Name: name,
          Phone: phone,
          ExecutId: this.ExecutId,
          RoomId: this.roomId,
          Pwd: this.pwd,
          Content: "您接收到一条视频通话请求！"
        }
      });

      //发送加入房间请求给主页面
      this.dispatch("ZjEmergencyOperations", "onJoinRoomRequestReceived", {
        Name: name,
        Phone: phone
      });
    }
  },
  watch: {
    PersonName: function() {
      this.GetUserData();
    }
  }
};
</script>